'use strict';

const { CLASSES } = require('./../utils/globals');
const inputDateHelper = require('./inputDateHelper');

const SELECTORS = {
    body: 'body',
    dateInput: '.js-input-date',
    inputFieldWrapper: '.js-field-wrapper',
    invalidFieldMessage: '.js-invalid-message',
    eventDependencies: '.js-event-dependencies',
    createEventForm: '.js-create-event-form-request',
    weddingDate: '.js-wedding-date'
};

const DEFAULT_FORMAT = 'MM-dd-y';

let reInitBound = false;

const getInputFieldParent = ($element) => $element.closest(SELECTORS.inputFieldWrapper);

/**
 * Site-preference threshold as a number of days (0 when unavailable).
 * @param {string} key - SitePreferences key
 * @returns {number} days
 */
const getThreshold = (key) => {
    const value = window.SitePreferences ? parseInt(window.SitePreferences[key], 10) : NaN;

    return isNaN(value) ? 0 : value;
};

/**
 * Initialise the accessible calendar on every `.js-input-date` on the page.
 * Idempotent: inputs that already have a calendar are skipped, so it is safe to
 * call again after a modal body is replaced (see the `inputDate:reInit` event).
 * Per-input overrides come from `data-date-format` (CLDR tokens) and
 * `data-min-days` on the input.
 * @returns {void}
 */
function initInputs() {
    $(SELECTORS.dateInput).each(function () {
        const $dateInput = $(this);
        const explicitMinDays = $dateInput.data('minDays');
        const hasExplicitMinDays = typeof explicitMinDays !== 'undefined' && explicitMinDays !== '';
        // Only the create-event form's own date field is subject to the event
        // thresholds. Other calendars on that page (the footer's event lookup
        // fields) keep their data-min-days / site-preference minimum.
        const isCreateEventDate = $(SELECTORS.eventDependencies).length > 0
            && $dateInput.closest(SELECTORS.createEventForm).length > 0;
        let format = $dateInput.data('dateFormat') || DEFAULT_FORMAT;
        let minDays = hasExplicitMinDays ? explicitMinDays : getThreshold('ORDER_THRESHOLD');

        if (isCreateEventDate && !hasExplicitMinDays) {
            minDays = 1;
        }

        // Special settings for swatch order form wedding date.
        if ($dateInput.hasClass(SELECTORS.weddingDate.substring(1))) {
            minDays = getThreshold('BLOCK_THRESHOLD');
            format = 'y-MM-dd';
        }

        inputDateHelper.initInput($dateInput, {
            format: format,
            minDays: minDays,
            onUpdate: function () {
                $dateInput.parent().removeClass(CLASSES.isInvalid);
                getInputFieldParent($dateInput).find(SELECTORS.invalidFieldMessage).empty();

                if (isCreateEventDate) {
                    validateEventDate();
                }
            }
        });
    });
}

/**
 * @description Initializes the accessible datepicker for each form input field
 */
function init() {
    if (!reInitBound) {
        $(SELECTORS.body).on('inputDate:reInit', initInputs);
        reInitBound = true;
    }

    initInputs();
}

/**
 * Validate the event date field based on thresholds.
 * Reads thresholds and error/warning messages from the hidden dependencies div.
 */
function validateEventDate() {
    // Remove any existing validation messages in the field wrapper.
    $('.date-validation-message').remove();

    var eventDateStr = $('#eventDate').val();
    if (!eventDateStr) {
         // No value entered—clear any messages and enable submit.
         $(SELECTORS.createEventForm).find('button[type="submit"]').prop('disabled', false);
         return;
    }

    var parts = eventDateStr.split('-');
    if (parts.length !== 3) {
         $('<div class="date-validation-message date-validation-error f-invalid-message js-invalid-message">Invalid date format. Please use MM-DD-YYYY.</div>')
             .insertAfter($('#eventDate').closest(SELECTORS.inputFieldWrapper));
         $(SELECTORS.createEventForm).find('button[type="submit"]').prop('disabled', true);
         return;
    }
    var month = parseInt(parts[0], 10) - 1; // JavaScript months are 0-based.
    var day   = parseInt(parts[1], 10);
    var year  = parseInt(parts[2], 10);
    var eventDate = new Date(year, month, day);

    var today = new Date();
    today.setHours(0, 0, 0, 0);

    // Calculate the difference in whole days.
    var diffTime = eventDate.getTime() - today.getTime();
    var diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    var $dependencies = $(SELECTORS.eventDependencies);
    var eventWarnThreshold = parseFloat($dependencies.data('eventwarnthreshold')); // e.g., 21.0
    var eventBlockThreshold = parseFloat($dependencies.data('eventblockthreshold')); // e.g., 13.0
    var warnMsg = $dependencies.data('warn-error-msg');
    var blockMsg = $dependencies.data('block-error-msg');

    if (diffDays <= eventBlockThreshold) {
         // If event date is ≤ 13 days away, show error message and disable submit.
         $('<div class="date-validation-message date-validation-error f-invalid-message js-invalid-message">' + blockMsg + '</div>')
             .insertAfter($('#eventDate').closest(SELECTORS.inputFieldWrapper));
         $(SELECTORS.createEventForm).find('button[type="submit"]').prop('disabled', true);
    } else if (diffDays < eventWarnThreshold) {
         // If event date is between 14 and 20 days away, show a warning but allow submit.
         $('<div class="date-validation-message date-validation-warning f-invalid-message js-invalid-message">' + warnMsg + '</div>')
             .insertAfter($('#eventDate').closest(SELECTORS.inputFieldWrapper));
         $(SELECTORS.createEventForm).find('button[type="submit"]').prop('disabled', false);
    } else {
         // For event dates 21+ days away, clear messages and allow submission.
         $(SELECTORS.createEventForm).find('button[type="submit"]').prop('disabled', false);
    }
}

module.exports = {
    init: init
};
